export const MAX_DOCUMENT_BYTES = 10 * 1024 * 1024

/** Reexporta la fuente única (ver `src/utils/status.ts`). */
export { formatBytes } from '~/utils/status'

export const documentIcon = (mime: string) => {
  if (mime.includes('pdf')) return 'material-symbols-light:picture-as-pdf-outline'
  if (mime.includes('image')) return 'material-symbols-light:image-outline'
  if (mime.includes('sheet') || mime.includes('excel')) return 'material-symbols-light:table-outline'
  if (mime.includes('word') || mime.includes('document')) return 'material-symbols-light:docs-outline'
  if (mime.includes('presentation') || mime.includes('powerpoint')) return 'material-symbols-light:slideshow-outline'
  return 'material-symbols-light:insert-drive-file-outline'
}

export const documentColor = (mime: string) => {
  if (mime.includes('pdf')) return 'bg-danger-soft text-danger'
  if (mime.includes('image')) return 'bg-success-soft text-success'
  if (mime.includes('sheet') || mime.includes('excel')) return 'bg-success-soft text-success'
  if (mime.includes('word') || mime.includes('document')) return 'bg-primary-soft text-primary'
  if (mime.includes('presentation') || mime.includes('powerpoint')) return 'bg-warning-soft text-warning'
  return 'bg-foreground-subtle/10 text-foreground-subtle'
}

export const activityIcon: Record<string, string> = {
  created: 'material-symbols-light:person-add-outline',
  quote: 'material-symbols-light:description-outline',
  invoice: 'material-symbols-light:receipt-long-outline',
  payment: 'material-symbols-light:payments-outline',
  call: 'material-symbols-light:call-outline',
  email: 'material-symbols-light:mail-outline',
  note: 'material-symbols-light:sticky-note-2-outline',
  blocked: 'material-symbols-light:block-outline',
  custom: 'material-symbols-light:history-outline'
}

export const activityColor: Record<string, string> = {
  created: 'text-primary bg-primary-soft',
  quote: 'text-info bg-info-soft',
  invoice: 'text-success bg-success-soft',
  payment: 'text-success bg-success-soft',
  call: 'text-warning bg-warning-soft',
  email: 'text-info bg-info-soft',
  note: 'text-foreground-subtle bg-surface-muted',
  blocked: 'text-danger bg-danger-soft',
  custom: 'text-foreground-subtle bg-surface-muted'
}
